import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { SearchRoutingModule } from 'src/app/pages/search/search-routing.module';

import { SearchComponent } from './search.component';
import { PeopleSearchResultComponent } from './people-search-result/people-search-result.component';
import { OrganizationSearchResultComponent } from './organization-search-result/organization-search-result.component';
import { DiscussionSearchResultComponent } from './discussion-search-result/discussion-search-result.component';
import { GroupSearchResultComponent } from './group-search-result/group-search-result.component';
import { EventSearchResultComponent } from './event-search-result/event-search-result.component';
import { SearchResultsListComponent } from './search-results-list/search-results-list.component';
import { SearchResultsTopComponent } from './search-results-top/search-results-top.component';
import { GroupsModule } from '../groups/groups.module';

@NgModule({
  declarations: [
    SearchComponent,
    PeopleSearchResultComponent,
    OrganizationSearchResultComponent,
    DiscussionSearchResultComponent,
    GroupSearchResultComponent,
    EventSearchResultComponent,
    SearchResultsListComponent,
    SearchResultsTopComponent
  ],
  imports: [CommonModule, SharedModule, SearchRoutingModule, GroupsModule]
})
export class SearchModule {}
